import { supabase } from './supabaseClient';

/**
 * Fetch redeemable games from Supabase
 * Redeemable games have status_code = 3
 * Ordered by game_id descending
 */
export async function fetchRedeemableGames() {
  try {
    const { data, error } = await supabase
      .from('solfire_games_data')
      .select('*')
      .eq('status_code', 3)
      .order('game_id', { ascending: false });

    if (error) {
      throw error;
    }

    return {
      games: data || [],
      error: null,
    };
  } catch (err) {
    console.error('Error fetching redeemable games:', err);
    return {
      games: [],
      error: err.message || 'Failed to fetch redeemable games',
    };
  }
}

/**
 * Fetch closed games from Supabase
 * Closed games have status_code = 4
 * Ordered by game_id descending
 */
export async function fetchClosedGames() {
  try {
    const { data, error } = await supabase
      .from('solfire_games_data')
      .select('*')
      .eq('status_code', 4)
      .order('game_id', { ascending: false });

    if (error) {
      throw error;
    }

    return {
      games: data || [],
      error: null,
    };
  } catch (err) {
    console.error('Error fetching closed games:', err);
    return {
      games: [],
      error: err.message || 'Failed to fetch closed games',
    };
  }
}
